// import { createSlice } from '@reduxjs/toolkit';

export const carouselMovies = [
  {
    id: '399566',
    title: 'Godzilla vs. Kong',
    backdrop_path: '/wWqTMWkEw6HouLd1zPZbZWxtAPr.jpg',
    overview:
      'In a time when monsters walk the Earth, humanity’s fight for its future sets Godzilla and Kong on a collision course that will see the two most powerful forces of nature on the planet.',
    vote_average: 8,
  },
  {
    id: '464052',
    title: 'Wonder Woman 1984',
    backdrop_path: '/srYya1ZlI97Au4jUYAktDe3avyA.jpg',
    overview:
      'A botched store robbery places Wonder Woman in a global battle against a powerful and mysterious ancient force that puts her powers in jeopardy.',
    vote_average: 6.7,
  },
  {
    id: '775996',
    title: 'Outside the Wire',
    backdrop_path: '/lOSdUkGQmbAl5JQ3QoHqBZUbZhC.jpg',
    overview:
      'In the near future, a drone pilot is sent into a deadly militarized zone and must work with an android officer to locate a doomsday device.',
    vote_average: 6.4,
  },
];
